import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './localops.css';

const getRoot = () => {
  if (typeof document === 'undefined') return null;
  const existing = document.getElementById('localops-sheet-root');
  if (existing) return existing;
  const el = document.createElement('div');
  el.id = 'localops-sheet-root';
  document.body.appendChild(el);
  return el;
};

export default function LocalOpsSheet({
  open,
  onClose,
  title,
  children,
  footer,
  ariaLabel,
  className = '',
  showClose = true,
  headerRight = null,
}) {
  const rootRef = useRef(getRoot());
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    setActive(false);
    const esc = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', esc);
    let raf = requestAnimationFrame(() => setActive(true));
    return () => {
      if (raf) cancelAnimationFrame(raf);
      window.removeEventListener('keydown', esc);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open || !rootRef.current) return null;

  return ReactDOM.createPortal(
    <div className="localops-sheet-backdrop" onClick={onClose}>
      <div
        className={`localops-sheet ${active ? 'is-open' : ''} ${className}`}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel || title || 'Panel'}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="localops-sheet__grab" />
        <div className="localops-sheet__header">
          <div className="localops-sheet__title-group">
            <h2 className="localops-sheet__title">{title}</h2>
            {headerRight ? (
              <div className="localops-sheet__header-actions">{headerRight}</div>
            ) : null}
          </div>
          {showClose ? (
            <button
              type="button"
              className="localops-sheet__close"
              onClick={onClose}
              aria-label="Close panel"
            >
              x
            </button>
          ) : null}
        </div>
        <div className="localops-sheet__content">{children}</div>
        {footer ? (
          <div className="localops-sheet__footer">{footer}</div>
        ) : null}
      </div>
    </div>,
    rootRef.current,
  );
}
